import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Params, RouterModule } from '@angular/router';

export interface Crumb {
  name: string;
  icon?: string;
  routerLink?: string | unknown[];
  queryParams?: Params;
}

@Component({
  selector: 'core-breadcrumb',
  imports: [CommonModule, RouterModule, MatIconModule],
  template: `
    <div class="flex text-base">
      @for (crumb of data; track crumb.name; let i = $index) {
        <div class="flex items-center">
          <a
            class="flex items-center"
            [attr.data-testid]="'crumb-link-' + i"
            [routerLink]="crumb.routerLink"
            [queryParams]="crumb.queryParams"
            [ngClass]="{ 'has-link': crumb.routerLink }"
          >
            @if (crumb.icon) {
              <mat-icon [attr.data-testid]="'crumb-icon-' + i">{{
                crumb.icon
              }}</mat-icon>
            }
            <span [attr.data-testid]="'crumb-label-' + i">{{
              crumb.name
            }}</span>
            @if (!$last) {
              <span class="mx-4" [attr.data-testid]="'crumb-separator-' + i">{{
                separator
              }}</span>
            }
          </a>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .has-link {
        @apply text-link;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  @Input()
  public data: Crumb[] = [{ name: '<NO CRUMBS>' }];

  @Input()
  public separator = '>';
}
